import BrandSelection from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/filter/components/brand-selection.mobile';

interface Props {
    data: any;
    query: string[] | undefined;
    onChange: (brandValue: string, isChecked: any) => void;
}

const BrandFilterTab = ({data, query, onChange}: Props) => {
    const getDefaultSatus = (value: string) => {
        if (!query || !query.length) return false;

        const index = query.findIndex(item => item === value);
        if (index === -1) return false;

        return true;
    };

    return (
        <div className="w-screen overflow-x-hidden">
            {data.map((brandsList: any, brandsListIndex: number) => (
                <div key={brandsListIndex} className="flex w-screen flex-col content-center justify-center">
                    <div className="w-screen bg-gray-200 pl-4">{brandsList.id}</div>
                    <li className="mx-4 w-screen list-none">
                        {brandsList.data.map((brand: any, brandIndex: number) => (
                            <ul key={brandIndex} className="my-5">
                                <BrandSelection
                                    brand={brand}
                                    defaultChecked={getDefaultSatus(brand.value)}
                                    onChange={onChange}
                                />
                            </ul>
                        ))}
                    </li>
                </div>
            ))}
        </div>
    );
};

export default BrandFilterTab;
